import {
  AsyncPipe,
  NgIf,
} from '@angular/common';
import {
  Component,
  OnInit,
  Type,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppliedFilter } from '../../../../../../../app/shared/search/models/applied-filter.model';
import { SearchLabelComponent as BaseComponent } from '../../../../../../../app/shared/search/search-labels/search-label/search-label.component';
import {
  DEFAULT_LABEL_OPERATOR,
  LABEL_DECORATOR_MAP,
} from '../../../../../../../app/shared/search/search-labels/search-label-loader/search-label-loader.decorator';

/**
 * BfS: search label that hides itself when the applied filter is part of the fixed filter query
 * (e.g. the relation filter `f.isPublicationOfSeries=<uuid>,equals` set by ds-related-entities-search).
 * Such a filter cannot be removed by the user and would only display the UUID of the related item.
 */
@Component({
  selector: 'ds-search-label',
  templateUrl: './search-label.component.html',
  styleUrls: ['../../../../../../../app/shared/search/search-labels/search-label/search-label.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgIf, RouterLink, TranslateModule],
})
export class SearchLabelComponent extends BaseComponent implements OnInit {

  /**
   * Emits true when this label belongs to the fixed filter query
   */
  isFixedFilter$: Observable<boolean>;

  ngOnInit(): void {
    super.ngOnInit();
    this.isFixedFilter$ = this.searchConfigurationService.getCurrentFixedFilter().pipe(
      map((fixedFilter: string) => isPartOfFixedFilter(this.appliedFilter, fixedFilter)),
    );
  }
}

/**
 * Checks whether the given applied filter is contained in the fixed filter query,
 * which has the form `f.<filter>=<value>,<operator>[&...]`
 */
function isPartOfFixedFilter(appliedFilter: AppliedFilter, fixedFilter: string): boolean {
  if (!appliedFilter || !fixedFilter) {
    return false;
  }
  return fixedFilter.split('&').some((part: string) => {
    const [key, rawValue] = part.split('=');
    if (key !== `f.${appliedFilter.filter}` || !rawValue) {
      return false;
    }
    const value = decodeURIComponent(rawValue);
    const separatorIndex = value.lastIndexOf(',');
    const filterValue = separatorIndex > -1 ? value.substring(0, separatorIndex) : value;
    return filterValue === appliedFilter.value;
  });
}

LABEL_DECORATOR_MAP.get(DEFAULT_LABEL_OPERATOR).set('bfs', SearchLabelComponent as Type<Component>);
